import { makeStyles, Theme, createStyles, Typography } from "@material-ui/core";
import React from "react";
import { ConnectionConfigDataRow } from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    typography: {
      fontSize: "0.875rem",
      marginTop: theme.spacing(2),
      marginButtom: theme.spacing(2),
    },
  })
);

interface Props {
  rowData: ConnectionConfigDataRow;
}

/** IPアドレス/サブネットマスク表示コンポーネント */
export function HostAndSubnetmaskRenderComponent(props: Props) {
  const classes = useStyles();

  const { rowData } = props;

  //--------------------
  // コンポーネント
  return (
    <>
      <div>
        <Typography className={classes.typography} component="span">
          {rowData.hostAndSubnetmask.host}
        </Typography>
      </div>
      <div>
        <Typography className={classes.typography} component="span">
          {rowData.hostAndSubnetmask.subnetMask}
        </Typography>
      </div>
    </>
  );
}
